import { EnterpriseMember } from 'models/Enterprises';

export type EnterpriseTeamMembersTable = Pick<
  EnterpriseMember,
  | 'firstName'
  | 'email'
  | 'seniority'
  | 'businessUnitName'
  | 'invitationStatus'
  | 'totalDeals'
  | 'totalListings'
  | 'successFee'
  | 'ev'
  | 'lastSeen'
  | 'totalContacts'
> &
  Record<'edit' | 'checkbox' | 'totalDataRooms', any>;

export type EnterpriseTeamMembersTableKeys = keyof EnterpriseTeamMembersTable;

export const RWC_TABLE_COLUMNS: EnterpriseTeamMembersTableKeys[] = [
  'checkbox',
  'firstName',
  'email',
  'seniority',
  'businessUnitName',
  'invitationStatus',
  'totalDataRooms',
  'totalContacts',
  'lastSeen',
  'edit',
];

export const TABLE_COLUMNS: EnterpriseTeamMembersTableKeys[] = [
  'checkbox',
  'firstName',
  'email',
  'seniority',
  'businessUnitName',
  'invitationStatus',
  'totalDeals',
  'totalListings',
  'totalContacts',
  'successFee',
  'ev',
  'lastSeen',
  'edit',
];

export const HEADING_TRANSLATIONS: Record<
  EnterpriseTeamMembersTableKeys,
  string
> = {
  checkbox: '',
  firstName: 'name',
  email: 'email',
  seniority: 'seniority',
  businessUnitName: 'businessUnit',
  invitationStatus: 'status',
  totalDeals: 'deals',
  totalListings: 'listings',
  totalContacts: 'contacts',
  successFee: 'commission',
  ev: 'capitalSigma',
  lastSeen: 'lastSeen',
  edit: 'edit',
  totalDataRooms: 'dataRooms',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<EnterpriseTeamMembersTableKeys, number>
> = {
  checkbox: 50,
  firstName: 250,
  email: 350,
  totalDeals: 50,
  totalListings: 50,
  edit: 50,
};

export const SORT_COLS: Partial<
  Record<EnterpriseTeamMembersTableKeys, string>
> = {
  firstName: 'sortName',
  email: 'email',
  seniority: 'seniority',
  businessUnitName: 'businessUnitName',
  invitationStatus: 'invitationStatusSort',
  totalDeals: 'totalDeals',
  totalListings: 'totalListings',
  totalContacts: 'totalContacts',
  successFee: 'successFee',
  ev: 'ev',
  lastSeen: 'lastSeen',
  totalDataRooms: 'totalDeals',
};

export const REQUIRED_COLUMNS: EnterpriseTeamMembersTableKeys[] = [
  'checkbox',
];

export const LOCKED_COLUMN: EnterpriseTeamMembersTableKeys = 'firstName';
